import type { SensorEquipment } from "../types/garage";

const NOW = "2026-07-31T10:15:00.000Z";

export const sensors: SensorEquipment[] = [
  {
    id: "sensor-garmin-edge-1040",
    category: "sensor",
    lifecycleStatus: "active",
    readinessStatus: "ready",
    archived: false,
    notes: "Primary outdoor head unit.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    name: "Garmin Edge 1040",
    type: "bike-computer",
    assignedBikeId: "bike-ultimate-2022",
    batteryPercent: 92,
    firmware: "24.13",
    lastSyncIso: "2026-07-31T10:02:00.000Z"
  },
  {
    id: "sensor-apple-watch-ultra-2",
    category: "sensor",
    lifecycleStatus: "active",
    readinessStatus: "ready",
    archived: false,
    notes: "Sleep and HRV tracking anchor.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    name: "Apple Watch Ultra 2",
    type: "watch",
    assignedBikeId: null,
    batteryPercent: 68,
    firmware: "watchOS 13.1",
    lastSyncIso: "2026-07-31T09:48:00.000Z"
  },
  {
    id: "sensor-core",
    category: "sensor",
    lifecycleStatus: "active",
    readinessStatus: "ready",
    archived: false,
    notes: "Thermal load data for heat blocks.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    name: "CORE",
    type: "core-temp",
    assignedBikeId: "bike-grail-2024",
    batteryPercent: 81,
    firmware: "3.4.0",
    lastSyncIso: "2026-07-31T09:51:00.000Z"
  },
  {
    id: "sensor-tymewear",
    category: "sensor",
    lifecycleStatus: "active",
    readinessStatus: "ready",
    archived: false,
    notes: "Used on select aerobic diagnostics days.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    name: "Tymewear",
    type: "respiratory",
    assignedBikeId: null,
    batteryPercent: 77,
    firmware: "1.8.6",
    lastSyncIso: "2026-07-31T09:50:00.000Z"
  }
];
